(() => {
  /* Keeps the builder's basket tray on the bottom edge of the screen.
     iPhone Safari (iOS 26) can leave bars that are pinned to the bottom
     floating where its toolbar used to be, after the toolbar hides or the
     keyboard closes. This measures that gap and slides the tray down into it.
     On other phones and on desktop the gap is always 0, so nothing moves. */
  const viewport = window.visualViewport;
  if (!viewport) return;
  let queued = false;

  function pin() {
    queued = false;
    const tray = document.getElementById('bndlr-mnm-status-box');
    if (!tray || tray.hidden || getComputedStyle(tray).position !== 'fixed') return;
    const current = Number(tray.dataset.pygShift || 0);
    const bottom = tray.getBoundingClientRect().bottom - current;
    const gap = Math.round(viewport.offsetTop + viewport.height - bottom);
    const next = gap > 1 && gap < 200 ? gap : 0;
    if (next === current) return;
    tray.dataset.pygShift = String(next);
    tray.style.setProperty('translate', next ? '0 ' + next + 'px' : 'none', 'important');
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(pin);
  }

  viewport.addEventListener('resize', queue);
  viewport.addEventListener('scroll', queue);
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('touchend', queue, { passive: true });
  document.addEventListener('focusout', () => setTimeout(queue, 300));
  setInterval(queue, 500);
  queue();
})();
